import { clickCollectInstance } from '.'
import { CCgetPathes, WalletPathes } from '../ApiGETPathes'
import { CardType } from './types'

const withToken = true

export class clickCollectGET {
  public static async customerCard(walletCardId?: string) {
    const result: CardType = await clickCollectInstance.get(
      walletCardId ? WalletPathes.GET_CARD : CCgetPathes.CARD,
      withToken,
      { cardId: walletCardId }
    )
    return result
  }

  public static async cardDetails() {
    const result: any = await clickCollectInstance.get(
      CCgetPathes.CARD_DETAILS,
      withToken,
      {},
      true,
      true
    )
    return result
  }
}
